import './DashboardFilterLine.scss';
import { MdWarningAmber } from 'react-icons/md';
import { FilterNode } from '@blisspointmedia/bpm-types/dist/querying';
import { dashboardFilterLabel } from './dashboard-filter-utils';

interface DashboardFilterLineProps {
  filters: FilterNode[];
  // The link's filter params could not be read, so the dashboard opened on its saved filters.
  filtersRejected?: boolean;
}

// The dashboard's filters as one read-only line under the header, like a card's "Filters:" line.
export const DashboardFilterLine = ({
  filters,
  filtersRejected = false
}: DashboardFilterLineProps) => {
  if (filters.length === 0 && !filtersRejected) return undefined;

  return (
    <div className='dashboard-filter-line'>
      {filters.length > 0 && (
        <span className='filters-applied'>
          <span className='filters-title'>Filters:</span>
          {filters.map(node => dashboardFilterLabel(node)).join(' · ')}
        </span>
      )}
      {filtersRejected && (
        <span className='filters-rejected'>
          <MdWarningAmber />
          This link&apos;s filters couldn&apos;t be read, so the saved filters are shown.
        </span>
      )}
    </div>
  );
};
